import React, { useState } from 'react';
import './education.css';

function Education() {

    const [shaddow, setShaddow] = useState("0 0 60px 20px var(--color-primary)");
    let timer = setTimeout(() => {
        if (shaddow === "0 0 60px 20px var(--color-primary)") {
            setShaddow("0 0 60px 5px var(--color-primary)");
        } else {
            setShaddow("0 0 60px 20px var(--color-primary)");
        }
    }, 100);
    return(
        <div>
            <section id='education'>
                <h5>What I'm Qualified In</h5>
                <h2>Education</h2>
                <div className='education__container'>
                    <div className='education__item'>
                        <div className='education__left'>
                            <h5 className='education__subject'>Bilborough College</h5>
                            <div className='link'>
                                <div className='link__circle left'/>
                                <div style={{'box-shadow': shaddow}} className='link__line'/>
                                <div className='link__circle'/>
                            </div>

                        </div>
                    </div>
                    <div className='education__details'>
                        <h4>Advanced Level</h4>
                        <div className='subjects'>
                            <h5>Mathematics</h5>
                            <h5>Physics</h5>
                            <h5>Computer-Science</h5>
                        </div>
                    </div>
                </div>

                <div className='education__container'>
                    <div className='education__item'>
                        <div className='education__left'>
                            <h5 className='education__subject'>University Of Leicester</h5>
                            <div className='link'>
                                <div className='link__circle left'/>
                                <div style={{'box-shadow': shaddow}} className='link__line short'/>
                                <div className='link__circle'/>
                            </div>

                        </div>
                    </div>
                    <div className='education__details'>
                        <h4>BSc Software Engineering</h4>
                        <div className='subjects'>
                            <h5>Due to Finish 2024</h5>
                        </div>
                    </div>
                </div>
                
            </section>
        </div>
    )
}

export default Education;